







import Vue from 'vue';
import {Component} from "vue-property-decorator";
import AsiToolbar from "../common/AsiToolbar.vue";
import BillList from "../bill/BillList.vue";
import {Icon} from "@/helpers/icons";
import CompanySimple from "../../models/company/CompanySimple";
import BillListFilter from "@/models/bill/BillListFilter";

@Component({
	components: {BillList, AsiToolbar}
})
export default class CustomerOpenBills extends Vue {

	private icons = Icon;
	private billFilterModel: BillListFilter | null = null;

	private get usersCompany(): CompanySimple | null {
		return this.$store.state.user.loggedInUser?.company ?? null;
	}

	public created(): void {
		this.billFilterModel = new BillListFilter();
		this.billFilterModel.isPaid = false;
	}

}
